import React from "react";

const MonthControls = ({
  monthValue,
  onMonthChange,
  onPrev,
  onNext,
}) => {
  const keyClick = (cb) => (e) => {
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); cb?.(); }
  };

  return (
    <div className="ufg-monthbar">
      <div
        role="button"
        tabIndex={0}
        className="ufg-action round"
        title="Poprzedni miesiąc"
        onClick={onPrev}
        onKeyDown={keyClick(onPrev)}
        aria-label="Poprzedni miesiąc"
      >
        «
      </div>

      <input
        type="month"
        value={monthValue}
        onChange={(e) => onMonthChange(e.target.value)}
        className="ufg-month-input"
        aria-label="Wybierz miesiąc"
      />

      <div
        role="button"
        tabIndex={0}
        className="ufg-action round"
        title="Następny miesiąc"
        onClick={onNext}
        onKeyDown={keyClick(onNext)}
        aria-label="Następny miesiąc"
      >
        »
      </div>
    </div>
  );
};

export default MonthControls;
